Helper = {
    loadProductCardScript: function() {
        if (document.querySelector(`script[src="//baudoinlange.com/cdn/shop/t/336/assets/product-card.js?v=94162183585331449971791820941"]`) === null) {
            // generate script
            const script = document.createElement('script');
            script.src = '//baudoinlange.com/cdn/shop/t/336/assets/product-card.js?v=94162183585331449971791820941';

            // product card styles
            const pcStyle = document.createElement('link');
            pcStyle.href = '//baudoinlange.com/cdn/shop/t/336/assets/product-card.css?v=41478994350623050711791820941';
            pcStyle.rel = "stylesheet";
            pcStyle.type = "text/css";

            // tooltip styles
            const tStyle = document.createElement('link');
            tStyle.href = '//baudoinlange.com/cdn/shop/t/336/assets/choose-size-tooltip.css?v=124351080397806865951791820941';
            tStyle.rel = "stylesheet";
            tStyle.type = "text/css";

            // append script and style
            document.head.appendChild(pcStyle);
            document.head.appendChild(tStyle);
            document.head.appendChild(script);
        }
        else {
            const event = new Event('reInitProductCardJS');
            document.dispatchEvent(event);
        }
    },
    getSelectedGender: function () {
        const selectedGender = localStorage.getItem('selected_gender');
        const defaultGender = localStorage.getItem("default_gender");
        return selectedGender || defaultGender;
    },
    isElementVisible: function (element, parent) {
        const elemRect = element.getBoundingClientRect();
        const parentRect = parent.getBoundingClientRect();
        const translateX = Helper.getXPosition(parent);

        return (
            elemRect.top >= parentRect.top &&
            elemRect.left + translateX + 1 >= parentRect.left &&
            elemRect.bottom <= parentRect.bottom &&
            elemRect.right + translateX - 1 <= parentRect.right
        );
    },
    visibleSidesCount: function (sliderElement, slides) {
        let visibleSlides = 0;

        slides.forEach((slide) => {
            if(Helper.isElementVisible(slide, sliderElement)) {
                visibleSlides ++;
            }
        });

        return visibleSlides;
    },
    isMobile: function () {
        return document.body.dataset.isMobile === "true";
    },
    isTablet: function () {
        return document.body.dataset.isTablet === "true";
    },
    isDesktop: function () {
        return document.body.dataset.isDesktop === "true";
    },
    addWindowResizeListener(callback) {
        if(!window) {
            return;
        }

        if(!callback) {
            return;
        }

        let windowWidth = window?.innerWidth || 0;
        let resizeTimeout;
        const resizeMethod = (event) => {
            if(windowWidth === window.innerWidth) {
                return;
            }

            const diff = Math.abs(windowWidth - window.innerWidth);
            if (diff < 20) {
                return;
            }

            clearTimeout(resizeTimeout);

            resizeTimeout = setTimeout(() => {
                windowWidth = window.innerWidth;
                callback();
            }, 300);
        };

        window.removeEventListener("resize", resizeMethod);
        window.addEventListener("resize", resizeMethod);
    },
    lazyLoadSection(sectionId) {
        if(!sectionId) {
            return;
        }

        const section = document.querySelector(`#lazy-section-${sectionId}[data-lazy-section]`);

        if(!section) {
            return;
        }

        const sectionUrl = `?section_id=${sectionId}&lazy=1`;

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const parent = section.closest('.shopify-section');

                    if(!parent) {
                        observer.unobserve(entry.target);
                        return;
                    }

                    // load content
                    fetch(sectionUrl)
                        .then(res => res.text())
                        .then(html => {

                            // load html
                            const tempDiv = document.createElement('div');
                            tempDiv.innerHTML = html;
                            parent.outerHTML = tempDiv.innerHTML;

                            // load scripts
                            const scripts = tempDiv.querySelectorAll('script');
                            scripts.forEach(script => {
                                const newScript = document.createElement('script');
                                if (script.src) {
                                    newScript.src = script.src;
                                } else {
                                    newScript.textContent = script.textContent;
                                }
                                document.body.appendChild(newScript);
                                script.remove();
                            });
                        });
                    observer.unobserve(entry.target);
                }
            });
        }, {
            rootMargin: 'px 0px px 0px' // visibility margin
        });

        observer.observe(section);
    },
    loadLazyAttributes(el) {
        el.querySelectorAll('*').forEach(child => {
            // process children
            if(child.childNodes.length) {
                this.loadLazyAttributes(child);
            }

            for (const attr of child.attributes) {
                if (attr.name.startsWith('data-lazy-')) {
                    const splittedAttrName = attr.name.split('data-lazy-')

                    // fill attributes
                    if(splittedAttrName[1]?.length > 0) {
                        child.setAttribute(splittedAttrName[1], child.getAttribute(attr.name));
                    }

                    // run video
                    if(child.tagName === 'VIDEO' && child.readyState < 3) {
                        child.load();
                    }
                }
            }
        });
    },
    getXPosition(element) {
        const transformStyle = window.getComputedStyle(element).transform;
        let translateX = 0;

        if (transformStyle !== 'none') {
            const matrix = new DOMMatrix(transformStyle);
            translateX = matrix.m41;
        }

        return translateX;
    },
    setActiveArrowPosition(item, parentRect, parentWrapper, calculatedLeftPosition, translateX) {
        const parentWrapperRect = parentWrapper.getBoundingClientRect();
        const parentWrapperStyle = window.getComputedStyle(parentWrapper);
        const itemActiveArrow = item.querySelector('.active-arrow');

        if(!itemActiveArrow) {
            return;
        }

        const itemActiveArrowRect = itemActiveArrow.getBoundingClientRect();
        const activeArrowPosition = (parentRect.left - parentWrapperRect.left) - calculatedLeftPosition + parentRect.width / 2 - itemActiveArrowRect.width / 2 + translateX + parseInt(parentWrapperStyle.marginLeft) + parseInt(parentWrapperStyle.marginRight);
        itemActiveArrow.style.left = `${activeArrowPosition}px`;
    },
    moveToItem(wrapper, parent, item) {
        requestAnimationFrame(() => {
            setTimeout(() => {
                item.style.left = 'initial';

                const parentWrapperRect = wrapper.getBoundingClientRect();
                const parentWrapperStyle = window.getComputedStyle(wrapper);
                const parentRect = parent.getBoundingClientRect();
                const titleBlockRect = item.getBoundingClientRect();
                const translateX = Helper.getXPosition(wrapper);

                let leftPosition = (parentRect.left - parentWrapperRect.left) + parentRect.width / 2 - titleBlockRect.width / 2 + translateX + parseInt(parentWrapperStyle.marginLeft) + parseInt(parentWrapperStyle.marginRight);

                item.classList.remove('far-away');
                item.classList.remove('right-position');

                if (parentWrapperRect.width - leftPosition < titleBlockRect.width) {
                    item.classList.add('right-position');

                    leftPosition = parentWrapperRect.width - titleBlockRect.width + translateX + parseInt(parentWrapperStyle.marginLeft);

                    if (!Helper.isElementVisible(parent, wrapper)) {
                        item.classList.add('far-away');
                    } else {
                        Helper.setActiveArrowPosition(item, parentRect, wrapper, leftPosition, translateX);
                    }

                    item.style.left = `${leftPosition}px`;

                    return;
                }

                if (leftPosition < 0) {
                    if (!Helper.isElementVisible(parent, wrapper)) {
                        item.classList.add('far-away');
                    }

                    leftPosition = parseInt(parentWrapperStyle.marginLeft);
                }

                Helper.setActiveArrowPosition(item, parentRect, wrapper, leftPosition, translateX);

                item.style.left = `${leftPosition}px`;

            }, 20);
        });
    },
    moveToActivatedItem(element, wrapper) {
        if(!element) {

            if(wrapper) {
                const titleBlock = wrapper?.parentNode?.parentNode?.querySelector('.active-title');

                if (titleBlock) {
                    titleBlock.style.opacity = '0';
                }
            }

            return;
        }

        const parentWrapper = element.parentNode.parentNode;
        const titleBlock = parentWrapper.parentNode?.querySelector('.active-title');

        if (!titleBlock) {
            titleBlock.style.opacity = '0';
            return;
        }

        const titleTextBlock = titleBlock.querySelector('span');

        if(!element.dataset.title.length) {
            return;
        }

        titleBlock.style.opacity = '1';
        titleTextBlock.textContent = element.dataset.title;
        Helper.moveToItem(parentWrapper, element, titleBlock);
    },
    moveToActiveItem(wrapper, className) {
        if(!wrapper) {
            return;
        }

        if(wrapper.target) {
            wrapper = wrapper.target;
        }

        if(!wrapper.classList.contains('swiper-wrapper')) {
            wrapper = wrapper.closest('.swiper-wrapper');
        }

        if(!wrapper) {
            return;
        }

        const item = wrapper.querySelector(className);

        Helper.moveToActivatedItem(item, wrapper);
    }
};